import * as PopperJS from '@popperjs/core';
import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import { Modifier, StrictModifierNames } from 'react-popper';

import { IPopover, PopoverMenu } from '@gem/ui-kit';

import { MessageViewPageType } from 'APP/main/ChatView/Messages/Messages.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useContextMenuPresenter } from './ContextMenu.presenter';

interface IContextMenuProps {
  message: ChatMessage;
  targetClick: HTMLElement | null;
  placement: PopperJS.Placement;
  modifiers?: ReadonlyArray<Modifier<StrictModifierNames>>;
  popover: IPopover;
  messageViewPageType: MessageViewPageType;
}

export const ContextMenu: FC<IContextMenuProps> = observer((props) => {
  const { message, popover, placement, modifiers, messageViewPageType, targetClick } = props;

  const { menuItems } = useContextMenuPresenter({
    message,
    messageViewPageType,
    targetClick,
  });

  useEffect(() => {
    if (!menuItems.length) {
      popover.close();
    }
  }, [menuItems]);

  return (
    <PopoverMenu
      isOpened
      menuItems={menuItems}
      reference={popover.containerRef.current}
      placement={placement}
      modifiers={modifiers}
      onClose={popover.close}
    />
  );
});
